import { useEffect, useState } from 'react';
import { Fab } from '@mui/material';
import { ReactComponent as GogoToTopBtn } from "assets/images/icons/icn_go_top.svg";

const FloatingButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const hasOverflow = document.body.scrollHeight > window.innerHeight;
      setShowButton(hasOverflow);
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    window.addEventListener('scroll', () => {
      setShowButton(window.scrollY > 100);
    });

    return () => {
      window.removeEventListener('resize', checkOverflow);
      window.removeEventListener('scroll', () => {
        setShowButton(window.scrollY > 100);
      });
    }
  }, []);

  return showButton ? (
    <Fab
      aria-label="top"
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 44,
        zIndex: 9999,
        backgroundColor: '#373737',
        "&:hover": {
          backgroundColor: '#707ca8',
        },
      }}
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }}
    >
      <GogoToTopBtn style={{
        width: '34px',
        height: '44px',
      }} />
    </Fab>
  ) : null;
}

export default FloatingButton;